// src/pages/Experiences.jsx
import React from 'react';
import Footer from '../components/Footer';
import SubHeader from '../components/SubHeader';



function Experiences() {
  return (
    <>
      <SubHeader />
      <main>
        <section className="page-header">
          <div className="page-header__bg"></div>
          <div className="container">
            <ul className="villoz-breadcrumb list-unstyled">
              <li><a href="/">Home</a></li>
            <li><span>Experiences</span></li>
            </ul>
            <h2 className="page-header__title">Experiences at Hanthana House Kandy</h2>
          </div>
        </section>

        {/* Experience List */}
        <section className="villa-page">
          <div className="container tabs-box">
            <div className="tabs-content">
              <div className="tab active-tab" id="list">
                <div className="row gutter-y-30">
                  {[
                    {
                      image: "/assets/images/activities/cookingclass/4.webp?v=20260924",
                      link: "/cookingclass",
                      title: "Sri Lankan Cooking Classes",
                      delay: "150ms"
                    },
                    {
                      image: "/assets/images/activities/teafactory/1.webp?v=20260924",
                      link: "/teafactoryvisits",
                      title: "A Visit to Tea Factories & Tea Estates",
                      delay: "200ms"
                    },
                    {
                      image: "/assets/images/activities/hanthanarange/4.webp?v=20260924",
                      link: "/hanthanarange",
                      title: "Hanthana Mountain Range Hiking & Trekking",
                      delay: "250ms"
                    },
                    {
                      image: "/assets/images/activities/pekoe/1.webp?v=20260924",
                      link: "/pekoe",
                      title: "The Pekoe Trail",
                      delay: "300ms"
                    }
                  ].map((experience, idx) => (
                    <div key={idx} className="col-lg-12">
                      <div
                        className="villa-card-list villa-card-list--full-width wow fadeInUp"
                        data-wow-delay={experience.delay}
                      >
                        <div className="row d-flex align-items-center">
                          <div className="col-lg-5">
                            <div className="villa-card-list__image">
                              <img src={experience.image} alt="experience" />
                            </div>
                          </div>
                          <div className="col-lg-7">
                            <div className="villa-card-list__content">
                              <h3 className="villa-card-list__title">
                                <a href={experience.link}>{experience.title}</a>
                              </h3>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default Experiences;
